module.exports = __webpack_public_path__ + "assets/img/infinity-icon.c1d8286d.png";